
export class FormField
{
    value:string;
    isValid:boolean;
    elementRef;
    initialValue;
}

class FormError extends Error
{
}

export interface FormProps
{
    onChange?:(fieldKey:string, fieldValue:any, isValid:boolean) => void
}

export class Form
{
    private _keyToField:any = {};
    private _props:FormProps;

    constructor(props?: FormProps)
    {
        this._props = props;
    }

    // -------------------------------------------------------------------------

    public onFieldChanged(fieldKey:string, fieldValue:any, isValid:boolean):void
    {
        let field = this._keyToField[fieldKey];

        if( !field )
            field = this._keyToField[fieldKey] = new FormField();

        field.value = fieldValue;
        field.isValid = isValid;

        if (this._props && this._props.onChange)
            this._props.onChange(fieldKey, fieldValue, isValid);
    }

    // -------------------------------------------------------------------------

    public setFieldKey(fieldKey:string, key:string, value):void
    {
        let field = this._keyToField[fieldKey];

        if( !field )
            field = this._keyToField[fieldKey] = new FormField();

        field[key] = value;
    }

    public setInitValue(fieldKey:string, value):void
    {
        let field = this._keyToField[fieldKey] as FormField;

        if( !field )
            field = this._keyToField[fieldKey] = new FormField();

        field.initialValue = value;
    }

    // -------------------------------------------------------------------------

    public get(fieldKey:string):string
    {
        let field = this._keyToField[fieldKey];

        if( !field )
            // throw new FormError(`Cannot find form field '${fieldKey}'`);
            field = this._keyToField[fieldKey] = new FormField();

        return field.value;
    }

    public getField(fieldKey:string):FormField
    {
        let field = this._keyToField[fieldKey];

        if( !field )
            field = this._keyToField[fieldKey] = new FormField();
            // throw new FormError(`Cannot find form field '${fieldKey}'`);

        return field;
    }

    public getFields(keys?:string[]):FormField[]
    {
        if (!keys)
            return this._keyToField;

        return keys.map(key => this._keyToField[key]);
    }

    // -------------------------------------------------------------------------

    public areAllFieldsValid(keys?:string[]):boolean
    {
        if (!keys)
            keys = Object.keys(this._keyToField);

        return keys.every(key => this._keyToField[key].isValid);
    }

    public areSomeFieldChanged(keys?:string[]):boolean
    {
        if (!keys)
            keys = Object.keys(this._keyToField);

        return keys.some(key => this._keyToField[key].initialValue !== this._keyToField[key].value);
    }

    // -------------------------------------------------------------------------
}
